RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _, s) {

    'use strict';

    views.SectionItem = Marionette.ItemView.extend({
        ui: {
            tooltips: '[data-toggle="tooltip"]'
        },

        getTemplate: function () {
            const me = this;
            if (me.model.get('name')) {
                return '#shellSectionItemTemplate';
            }

            return false;
        },
        tagName: 'li',
        behaviors: {
            MenuItem: {
                behaviorClass: App.behaviors.MenuItem,
                className: 'active'
            }
        },

        events: {
            'click .deletable': 'onClickDelete'
        },

        onClickDelete: function (e) {
            const me = this;
            e.stopPropagation();
            e.preventDefault();
            me.model.get('deleteHandler')();
        },

        className: function () {
            const me = this;

            const className = me.model.get('className');
            const classNames = [];

            if (className) {
                classNames.push(className);
            }

            const isDisabled = (RivalIQ.state.account.trialExpired() && !me.model.get('enabledForExpired')) || (RivalIQ.state.account.isCancelled() && !me.model.get('enabledForCancelled'));
            if (RivalIQ.state.account.trialExpired() || RivalIQ.state.account.isCancelled()) {
                classNames.push(!isDisabled ? 'trial-enabled' : 'disabled');
                return classNames.join(' ');
            }

            if (me.isDisabled()) {
                classNames.push('disabled');
            }
            return classNames.join(' ');
        },

        isDisabled: function () {
            const me = this;

            return _.result(me.model.attributes, 'disabled');
        },

        serializeData: function () {
            const me = this;

            const model = me.model.toJSON();

            return _.defaults(model, {
                icon: '',
                className: '',
                target: '',
                isBetaItem: false,
                customLabel: null,
                showTooltip: false,
                displayName: model.name,
                newPill: null
            });
        },

        templateHelpers: function () {
            const me = this;
            const templateHelpers = App.mixins.Navigable.templateHelpers.apply(me, arguments);
            return _.defaults({
                getId: function () {
                    const data = this;
                    if (data.name) {
                        const name = data.name.toLowerCase();
                        return s.slugify(s.dasherize(s.stripTags(name)));
                    }
                },
                isDeletable: _.constant(me.model.get('deletable'))
            }, templateHelpers);
        },

        onRender: function () {
            const me = this;
            me.ui.tooltips.tooltip();
        }
    });

    views.SectionLink = views.SectionItem.extend({
        behaviors: {}
    });

}, window.s);
